import AskMeAnything from '../../../../../components/AskMeAnything';

const AskMeAnythingTab = () => {
  return (
    <AskMeAnything
      showLabel
      placeholder={'Ask a question about this contract'}
    />
  );
};

export default AskMeAnythingTab;
